export const formatTxn = (account: string) => {
  if (!account) return '';
  const first = account.substring(0, 12);
  const last = account.substring(account.length - 8);
  return `${first}...${last}`;
};
